import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Alert, NewsService } from '../services/news.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Component({
    selector: 'app-news-bar',
    templateUrl: './news-bar.component.html',
    styleUrls: ['./news-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsBarComponent implements OnInit {

    firstNews$: Observable<Alert[]>;
    news$: Observable<Alert[]>;
    hasNews$: Observable<boolean>;

    constructor(private service: NewsService) { }

    ngOnInit() {

        this.firstNews$ = this.service.sharedNews$
            .pipe(
                map(news => !!news ? news.slice(0) : [])
            );

        this.news$ = this.firstNews$;

        this.hasNews$ = this.news$.pipe(map(news => !!news.length));

    }

    private toAlert(type: string, message: string): Alert {
        return { type, message };
    }

}

